import axios from 'axios';
import { apiURL } from './apiURL';

const publicAPI = axios.create({
  baseURL: apiURL,
});

export default publicAPI;
